module.exports = __webpack_public_path__ + "img/PayMethod-LinePay.596f3de1.png";